ko.bindingHandlers["transitionEnd"] =
   init: (element, valueAccessor) ->
      value = ko.unwrap(valueAccessor())
      $(element).on("transitionend", value)